export const retractionAnimationDuration = 2;
